import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";

const DEFAULT_BUTTON_TEXT = "Ok";

interface OwnTypes {
    title: string,
    children: any,
    isOpen: boolean,
    onClose: () => void,
    onMainAction: () => void,
    buttonText?: string,
    buttonColor?: string,
    isDisabled?: boolean
}

const ModalDialogue = ({ title, children, isOpen, onClose, onMainAction, buttonText, buttonColor, isDisabled }:OwnTypes) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          <Button colorScheme={buttonColor || "blue"} mr={3} onClick={onMainAction} isDisabled={isDisabled || false}>
            { buttonText || DEFAULT_BUTTON_TEXT }
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalDialogue;